import { render, staticRenderFns } from "./RoySimpleTextInTable.vue?vue&type=template&id=73b3d8c6&"
import script from "./RoySimpleTextInTable.vue?vue&type=script&lang=js&"
export * from "./RoySimpleTextInTable.vue?vue&type=script&lang=js&"
import style0 from "./RoySimpleTextInTable.vue?vue&type=style&index=0&id=73b3d8c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports